import { type Ref } from "vue";

import { useBrowserStore } from "@/composables/useBrowserStore";
import type { UseProfile } from "@/composables/useProfile";

// App-lifetime singleton: the synced state (and its detached persistence
// watcher) is deliberately never released — it is cached at module level and
// must keep persisting after the first calling component unmounts.
let soundPreference: Ref<boolean> | undefined;

export function useSoundReminder(profile: Ref<UseProfile>) {
  if (!soundPreference) {
    const { syncState } = useBrowserStore(profile.value.user.accountId);
    soundPreference = syncState<boolean>("reminders/event:sound", true);
  }

  const preEventSound = soundPreference;
  const togglePreEventSound = (value: boolean) => {
    if (!preEventSound) return;
    preEventSound.value = value;
  };

  return {
    preEventSound,
    togglePreEventSound,
  };
}
